module.exports = __webpack_public_path__ + "static/media/tik-tok_ftr.834e57d0.svg";